var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"clickArea",staticClass:"click-area",on:{"click":_vm.onClick,"animationend":_vm.endAnimation}},[_vm._t("default"),_c('div',{ref:"shineDiv",staticClass:"shine",style:({left: _vm.x + 'px', top: _vm.y + 'px'})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }